// HOLDOUTGROUP : holdout-q1-2026-pdm

//KEY: social-badge
const social_badge = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue("holdout-q1-2026-pdm", "OFF");

  if (holdoutGroup === "holdout-q1-2026-pdm") return;

  const variant = window._growthbook.getFeatureValue("social-badge", 0);

  switch (variant) {
    case 1:
      console.log("social-badge | variant: 1");
      document.querySelectorAll(".product-media__badge.image-badge__test").forEach((el) => {
        el.classList.remove("image-badge__test");
      });
      break;

    case 2:
      console.log("social-badge | variant: 2");
      document.querySelectorAll(".product-badge-block__inner.badge-block__inner-test").forEach((el) => {
        el.classList.remove("badge-block__inner-test");
      });
      break;

    default:
      return;
  }
};

//KEY: header-shop-now
const header_shop_now = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue("holdout-q1-2026-pdm", "OFF");

  if (holdoutGroup === "holdout-q1-2026-pdm") return;

  const variant = window._growthbook.getFeatureValue("header-shop-now", 0);

  if (variant === 0) return;

  const cssUrl = variant === 1
    ? window.pdmAssets?.headerMobileTestCss
    : window.pdmAssets?.headerMobileTestBCss;

  if (cssUrl && !document.querySelector(`link[href="${cssUrl}"]`)) {
    const link = document.createElement("link");
    link.rel  = "stylesheet";
    link.href = cssUrl;
    document.head.appendChild(link);
  }

  console.log(`header-shop-now | variant: ${variant}`);

  const injectBtn = () => {
    if (window.innerWidth > 767) return;
    const iconsRight = document.querySelector(".header__icons-right");
    if (iconsRight && !iconsRight.querySelector(".header-test-shop-now")) {
      const btn = document.createElement("a");
      btn.className = "header-test-shop-now";
      btn.href      = "https://uresta.com/products/the-uresta-starter-kit";
      btn.textContent = "Shop Now";
      btn.setAttribute("aria-label", "Shop Now");
      iconsRight.insertBefore(btn, iconsRight.firstChild);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", injectBtn);
  } else {
    injectBtn();
  }
};


(() => {
  window.growthbook_queue = window.growthbook_queue || [];

  window.growthbook_queue.push((gb) => {
    // Runs when GrowthBook loads, and again whenever GrowthBook receives new data
    const applyFeatureFlags = () => {
      // Call the flag readers here:
      pdp_reviews();
      social_badge();
      header_shop_now();
    };

    applyFeatureFlags();
    document.addEventListener("growthbookdata", applyFeatureFlags);
  });
})();

